import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionType, Response } from '@ui/src';
import { transactionStatusApi } from './service';
import {
  TransactionStatusReport,
  TransactionStatusReportResponse,
} from '../types';
import calculateTotal from '../helpers/calculate-total';

export interface TransactionsStatusState {
  transactionTypes?: TransactionType[];
  transactionsStatus?: TransactionStatusReport[];
}

const initialState: TransactionsStatusState = {};

export const transactionsStatusSlice = createSlice({
  name: 'transactionsStatus',
  initialState,
  reducers: {
    clearReport: (state) => {
      state.transactionsStatus = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      transactionStatusApi.endpoints.getTransactionStatusReport.matchFulfilled,
      (
        state,
        action: PayloadAction<{ data: TransactionStatusReportResponse }>,
      ) => {
        state.transactionsStatus = calculateTotal(action.payload.data.stats);
      },
    );
    builder.addMatcher(
      transactionStatusApi.endpoints.getReportsTransactionsTypes.matchFulfilled,
      (state, action: PayloadAction<Response<TransactionType>>) => {
        state.transactionTypes = action.payload.data.edges?.map(
          (item) => item.node,
        );
      },
    );
  },
});

export const { clearReport } = transactionsStatusSlice.actions;

export default transactionsStatusSlice.reducer;
